import {ChangeEventHandler} from "react";

export default function Toggle(props: ToggleProps){
    return (
        <label className="inline-flex items-center cursor-pointer">
            <input type="checkbox" value="" checked={props.checked} onChange={props.onChange} className="sr-only peer"/>
            <div
                className="relative w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
            {props.label && (<span className="ms-3 text-sm font-medium text-white dark:text-gray-300">{props.label}</span>)}
        </label>
    )
}

export interface ToggleProps{
    label?: string
    checked?: boolean
    onChange?: ChangeEventHandler<HTMLInputElement>
}